import { GqlRequestOptions } from '@common/api-request';
import { isExternalReviewVersion } from '@common/app-manager';

import { PdpProductEntryType } from '../graphql/pdp-base-info_types.2';
import { usePdpBaseInfo } from './usePdpBaseInfo';
import { useGetPdpIntegratedData } from './usePdpIntegratedData';

export const useProductReviewTotalCount = (productId: string, options?: GqlRequestOptions) => {
  const { product } = usePdpBaseInfo({ catalog_product_id: productId });
  const { related_product_review_summary } = useGetPdpIntegratedData({
    catalog_product_id: productId,
    ...options,
  });

  const isAvailableExternalReview = product.entry_type !== PdpProductEntryType.DIRECT;

  const isShowExternalReviewCount =
    isExternalReviewVersion() &&
    isAvailableExternalReview &&
    related_product_review_summary?.all_count_external_included;

  return {
    review_total_count:
      (isShowExternalReviewCount
        ? related_product_review_summary?.all_count_external_included
        : related_product_review_summary?.all_count) ?? 0,
  };
};
